import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as actions from './actions'
import * as api from './api'
import { message } from 'antd'

function* fetchArcCategoriesWorker() {
  try {
    const { data } = yield call(api.getArcCategories)
    if (data) {
      yield put(
        actions.fetchArcCategoriesSuccess({
          categories: data.data,
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcCategoriesFailure())
  }
}

function* createArcCategoryWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    const response = yield call(api.createArcCategory, payload.data)
    if (response) {
      yield put(actions.createArcCategorySuccess())
      message.success('Category created successfully!')
      if (payload.callback) {
        payload.callback()
      }
    }
  } catch (error) {
    console.error(error)
    yield put(actions.createArcCategoryFailure())
    message.error('Failed to create category')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* updateArcCategoryWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    const response = yield call(api.updateArcCategory, payload.id, payload.data)
    if (response) {
      yield put(actions.updateArcCategorySuccess())
      message.success('Category updated successfully!')
      if (payload.callback) {
        payload.callback()
      }
    }
  } catch (error) {
    console.error(error)
    yield put(actions.updateArcCategoryFailure())
    message.error('Failed to update category')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* deleteArcCategoryWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    const response = yield call(api.deleteArcCategory, payload.id)
    if (response) {
      yield put(actions.deleteArcCategorySuccess())
      message.success('Category deleted successfully!')
      if (payload.callback) {
        payload.callback()
      }
    }
  } catch (error) {
    console.error(error)
    yield put(actions.deleteArcCategoryFailure())
    message.error('Failed to delete category')
  } finally {
    yield put(actions.finishSaving())
  }
}

export default function* () {
  yield all([
    takeLatest(actions.fetchArcCategories, fetchArcCategoriesWorker),
    takeLatest(actions.createArcCategory, createArcCategoryWorker),
    takeLatest(actions.updateArcCategory, updateArcCategoryWorker),
    takeLatest(actions.deleteArcCategory, deleteArcCategoryWorker),
  ])
}